// extracted by mini-css-extract-plugin
export var footer = "_mr-0";
export var inherit = "_mr-1";
export var input = "_mr-2";
export var modalContent = "_mr-3";
export var quillEditor = "_mr-4";
export var subtitle = "_mr-5";